import { __rest, __assign } from 'tslib';
import { jsxs, jsx } from 'react/jsx-runtime';

var NavigationLeftSolidIcon = function (_a) {
    var title = _a.title, props = __rest(_a, ["title"]);
    return (jsxs("svg", __assign({ width: "1em", height: "1em", viewBox: "0 0 24 24", fill: "none", "data-ui-icon": true }, props, { children: [title ? jsx("title", { children: title }) : null, jsx("path", { d: "M12.5 5.501a8.955 8.955 0 00-6.144 2.442L4.207 5.794a.999.999 0 00-1.707.707v11a1 1 0 001 1h11a1.002 1.002 0 00.707-1.707l-3.51-3.509a3.99 3.99 0 016.63-1.611 4.005 4.005 0 011.173 2.825v.002a1 1 0 002 0v-.005c-.002-4.96-4.039-8.995-9-8.995z", fill: "currentColor" })] })));
};

export { NavigationLeftSolidIcon };
//# sourceMappingURL=NavigationLeftSolidIcon.js.map
